import React, { useEffect, useState } from 'react';
import BossDialog from '../../components/BossDialog';
import { EditPageHeader } from '../../components/EditPageHeader';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { useTranslation } from '../../locale/useTranslation';
import { utility } from '../../framework/utility/utilityProvider';
import { ADS_TYPE, ENTITYNAME, TOAST_TYPES } from '../../framework/constant/constant';
import * as API from '../../framework/API/api';
import { Grid, GridColumn as GridColumn } from "@progress/kendo-react-grid";
import moment from 'moment';
import { META_STATUS_TYPE } from './SocialMediaConstant';
import AddRoundButton from '../../framework/forms/helpercomponents/buttons/AddRoundButton';
import SMAdsetForm from './SMAdsetForm';
import MetaCampaignEditForm from './Meta/MetaCampaignEditForm';
import PublishOrUnPublishStatusCard from './PublishOrUnPublishStatusCard';
import { DateTimeCell } from '../../framework/forms/helpercomponents/CustomGridCells/DateCell';
import GoogleCampaignForm from './Google/GoogleCampaignForm';
import { MenuCommandCell } from '../../framework/forms/helpercomponents/CustomGridCells/MenuCommandCell ';
import LinkedinCampaignForm from './LinkedIn/LinkedinCampaignForm';
import ToastNotification from "../../components/ToastNotification";

const SMCampaignEditForm = ({ onClose, item = {}, budgetData = {}, onSave, campaignData = [] }) => {

    const lang = useTranslation();

    const getFinalData = (value) => {
        switch (value?.channel?.adType) {
            case ADS_TYPE.META:
                return {
                    objective: value?.meta?.objective ? { _id: value?.meta?.objective, description: value?.meta?.objective } : {},
                    buying_type: value?.meta?.buying_type ? { _id: value?.meta?.buying_type, description: value?.meta?.buying_type } : {},
                    bid_strategy: value?.meta?.bid_strategy ? { _id: value?.meta?.bid_strategy, description: value?.meta?.bid_strategy } : {},
                    spend_cap: value?.meta?.spend_cap ?? '',
                    daily_budget: value?.meta?.daily_budget ?? '',
                    special_ad_categories: value?.meta?.special_ad_categories && value?.meta?.special_ad_categories.length > 0 ? value?.meta?.special_ad_categories.map((x) => ({ _id: x, description: x })) : [],
                    metaCampaignId: value?.meta?.metaCampaignId ?? null,
                }
            case ADS_TYPE.GOOGLE:
            case ADS_TYPE.YOUTUBE:
                return {
                    advertising_channel_type: value?.google?.advertising_channel_type ? { _id: value?.google?.advertising_channel_type, description: value?.google?.advertising_channel_type } : {},
                    cpc_bid_micros: value?.google?.cpc_bid_micros ?? '',
                    googleCampaignId: value?.googleCampaignId ?? null,
                    youtubeCampaignId: value?.youtubeCampaignId ?? null
                }
            case ADS_TYPE.LINKEDIN:
                return {
                    daily_budget: value?.linkedin?.daily_budget ?? '',
                    spend_cap: value?.linkedin?.spend_cap ?? '',
                    type: value?.linkedin?.type ? { _id: value?.linkedin?.type, description: value?.linkedin?.type } : {},
                    objectiveType: value?.linkedin?.objectiveType ? { _id: value?.linkedin?.objectiveType, description: value?.linkedin?.objectiveType } : {},
                    costType: value?.linkedin?.costType ? { _id: value?.linkedin?.costType, description: value?.linkedin?.costType } : {},
                    linkedinCampaignId: value?.linkedin?.linkedinCampaignId ?? null,
                }
        }
    }

    const blankDataItem = {
        _id: item?._id,
        name: item?.name ?? '',
        budget: item?.budget ?? {},
        channel: item?.channel ?? {},
        start_time: item?.start_time ? moment(item?.start_time).format('YYYY-MM-DD HH:mm:ss') : moment().format('YYYY-MM-DD HH:mm:ss'),
        end_time: item?.end_time ? moment(item?.end_time).format('YYYY-MM-DD HH:mm:ss') : moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
        ...getFinalData(item),
    }

    const [dataItem, setDataItem] = useState(blankDataItem);
    const [channels, setChannels] = useState([]);
    const [budgets, setBudgets] = useState([]);
    const [adsetData, setAdsetData] = useState(item?.ad_data ?? []);
    const [showAdsetPopup, setShowAdsetPopup] = useState({ show: false, item: {} });
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        loadCombo();
    }, [])

    const loadCombo = async () => {
        let channelRes = await API.getDataLookup(ENTITYNAME.SM_Channels);
        setChannels(channelRes.data);
        setBudgets([{ description: budgetData?.description, _id: budgetData?._id ?? null }]);
        if (!item?._id && !item?.index) setDataItem({ ...dataItem, channel: utility.getDefaultItem(channelRes.data), budget: { description: budgetData?.description, _id: budgetData?._id ?? null }, start_time: moment(budgetData?.fromDate).format('YYYY-MM-DD HH:mm:ss'), end_time: moment(budgetData?.toDate).endOf('day').format('YYYY-MM-DD HH:mm:ss') });
    }

    const onChange = (e) => {
        const { name, value } = e.target;
        setDataItem({ ...dataItem, [name]: value });
    };

    // const handleAdsetDelete = (value, index) => {
    //     const updatedAdData = adsetData.filter((x, i) => i !== index);
    //     setAdsetData(updatedAdData);
    // }

    const handleAdsetCreate = (data) => {
        if (data?.index !== undefined) {
            const updatedAdData = adsetData.map((x, i) => {
                if (i === data.index) return data;
                return x;
            });
            setAdsetData(updatedAdData);
        } else {
            setAdsetData([...adsetData, data]);
        }
    }

    const calculateRemainingSpendCap = () => {
        const targetAmount = parseInt(budgetData.targetAmount) || 0;

        const getSpendCap = (campaign) => {
            const adType = campaign.channel?.adType;
            switch (adType) {
                case 'META':
                    return parseInt(campaign.meta?.spend_cap) || 0;
                case 'GOOGLE':
                    return parseInt(campaign.google?.cpc_bid_micros) || 0;
                default:
                    return 0;
            }
        };

        const totalSpendCap = campaignData.reduce((total, campaign) => {
            if (item?.index !== undefined && campaign._id === item._id) {
                return total;
            }
            return total + getSpendCap(campaign);
        }, 0);

        return targetAmount - totalSpendCap;
    };


    const isValid = () => {

        if (!dataItem.name || dataItem.name === "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_name_error_message })
            return false
        }
        if (!dataItem.channel || Object.keys(dataItem.channel).length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_channel_error_message })
            return false
        }
        if (!dataItem.budget || Object.keys(dataItem.budget).length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_budget_error_message })
            return false
        }
        if (!dataItem.start_time || dataItem.start_time === "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_start_time_error_message })
            return false
        }
        if (!dataItem.end_time || dataItem.end_time === "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_end_time_error_message })
            return false
        }
        if (dataItem.end_time < dataItem.start_time) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.end_time_cannot_be_earlier_than_start_time_message })
            return false
        }
        switch (dataItem.channel?.adType) {
            case ADS_TYPE.META:
                if (!dataItem.objective || Object.keys(dataItem.objective).length == 0) {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_objective_error_message })
                    return false
                }
                if (!dataItem.buying_type || Object.keys(dataItem.buying_type).length == 0) {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_buying_type_error_message })
                    return false
                }
                if (!dataItem.bid_strategy || Object.keys(dataItem.bid_strategy).length == 0) {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_bid_strategy_error_message })
                    return false
                }
                if (!dataItem.spend_cap || dataItem.spend_cap === "") {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_spend_cap_error_message })
                    return false
                }
                if (parseInt(dataItem.spend_cap) > calculateRemainingSpendCap()) {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_spend_cap_cannot_exceed_available_budget_error_message });
                    return false
                }
                if (!dataItem.daily_budget || dataItem.daily_budget === "") {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_daily_budget_error_message })
                    return false
                }
                if (parseInt(dataItem.daily_budget) > parseInt(dataItem.spend_cap)) {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_daily_budget_cannot_exceed_spend_cap_error_message });
                    return false
                }
                break;
            case ADS_TYPE.GOOGLE:
            case ADS_TYPE.YOUTUBE:
                if (!dataItem?.advertising_channel_type || Object.keys(dataItem?.advertising_channel_type).length == 0) {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_advertising_channel_type_error_message });
                    return false
                }
                if (!dataItem?.cpc_bid_micros || dataItem?.cpc_bid_micros === 0) {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_cpc_bid_micros_error_message })
                    return false
                }
                break;
            case ADS_TYPE.LINKEDIN:
                if (!dataItem?.objectiveType || Object.keys(dataItem?.objectiveType).length == 0) {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_linkedin_objective_type_error_message })
                    return false
                }
                if (!dataItem?.type || Object.keys(dataItem?.type).length == 0) {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_linkedin_type_error_message })
                    return false
                }
                if (!dataItem?.spend_cap || dataItem?.spend_cap === 0) {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_spend_cap_error_message })
                    return false
                }
                if (!dataItem?.daily_budget || dataItem?.daily_budget === 0) {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_daily_budget_error_message })
                    return false
                }
                if (dataItem?.spend_cap < dataItem?.daily_budget) {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_spend_cap_cannot_exceed_available_budget_error_message });

                    return false
                }
                break;
        }

        if (adsetData?.length === 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'Please add at least one adset' });
            return false;
        }
        return true;
    }

    const saveFinalData = (value) => {
        switch (value?.channel?.adType) {
            case ADS_TYPE.META:
                return {
                    meta: {
                        objective: value?.objective && Object.keys(value?.objective).length > 0 ? value.objective.description : {},
                        buying_type: value?.buying_type && Object.keys(value?.buying_type).length > 0 ? value.buying_type.description : {},
                        bid_strategy: value?.bid_strategy && Object.keys(value?.bid_strategy).length > 0 ? value.bid_strategy.description : {},
                        spend_cap: value?.spend_cap ? parseFloat(value?.spend_cap) : 0,
                        daily_budget: value?.daily_budget ? parseFloat(value?.daily_budget) : 0,
                        special_ad_categories: value?.special_ad_categories && value?.special_ad_categories.length > 0 ? value.special_ad_categories.map((x) => { return x.description }) : [],
                    }
                }
            case ADS_TYPE.GOOGLE:
            case ADS_TYPE.YOUTUBE:
                return {
                    google: {
                        advertising_channel_type: value?.advertising_channel_type && Object.keys(value?.advertising_channel_type).length > 0 ? value.advertising_channel_type.description : null,
                        cpc_bid_micros: value?.cpc_bid_micros ? parseFloat(value?.cpc_bid_micros) : 0,
                        googleCampaignId: value?.googleCampaignId ?? null
                    }
                }
            case ADS_TYPE.LINKEDIN:
                return {
                    linkedin: {
                        type: value?.type && Object.keys(value?.type)?.length > 0 ? value?.type?.description : null,
                        objectiveType: value?.objectiveType && Object.keys(value?.objectiveType)?.length > 0 ? value?.objectiveType?.description : null,
                        daily_budget: value?.daily_budget ? parseFloat(value?.daily_budget) : 0,
                        spend_cap: value?.spend_cap ? parseFloat(value?.spend_cap) : 0,
                        costType: value?.costType && Object.keys(value?.costType)?.length > 0 ? value?.costType?.description : null
                    }
                }
        }
    }

    const handleSubmit = async (e) => {
        if (!isValid()) return;
        const finalData = {
            _id: dataItem?._id,
            channel: dataItem?.channel && Object.keys(dataItem?.channel).length > 0 ? { _id: dataItem?.channel?._id, adType: dataItem?.channel?.adType } : {},
            budget: dataItem?.budget && Object.keys(dataItem?.budget).length > 0 ? { _id: dataItem?.budget?._id, description: dataItem?.budget?.description } : {},
            name: dataItem?.name ?? "",
            start_time: dataItem?.start_time ? utility.convertStringDatetoMilliseconds(dataItem?.start_time) : "",
            end_time: dataItem?.end_time ? utility.convertStringDatetoMilliseconds(dataItem?.end_time) : "",
            ad_data: adsetData?.length > 0 ? adsetData : [],
            ...saveFinalData(dataItem),
        };
        onSave && onSave(finalData);
    };

    const onPublishOrUnpublish = async (value = {}, isPublished = false) => {
        if (!dataItem?._id) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'Please save campaign first' });
            return;
        }
        setIsLoading(true);
        let res = await API.publishOrUnPublishCampaign({ campaign_id: dataItem?._id, ad_id: value?._id, isPublished });
        if (!res?.success) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res?.message });
            setIsLoading(false);
            return;
        }
        let updateData = adsetData.map(x => {
            if (x?._id === value?._id) {
                return {
                    ...x,
                    status: isPublished ? META_STATUS_TYPE.ACTIVE : META_STATUS_TYPE.PAUSED
                }
            }
            return x;
        })
        setAdsetData(updateData);
        ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: res?.message });
        setIsLoading(false);
    }

    const handleAdsetEdit = (value = {}, index) => {
        setShowAdsetPopup({ show: true, item: { ...value, index } });
    }

    const smCampaignMenuModel = (props) => {
        const menu = [
            {
                label: 'Options',
                items: [
                    // {label: 'Delete',icon: 'pi pi-trash',command: () => ConfirmDeleteAlert(() => props.onDelete(props.dataIndex, props.dataItem), () => { })},
                    { label: 'Edit', icon: 'pi pi-pencil', command: () => props.onEdit(props.dataItem, props.dataIndex) },
                    { label: 'Publish', icon: 'pi pi-arrow-up', command: () => props.onPublish(props.dataItem, props.dataIndex, true) },
                    { label: 'Unpublish', icon: 'pi pi-arrow-down', command: () => props.onUnPublish(props.dataItem, props.dataIndex, false) }
                ]
            }
        ]
        return menu;
    }

    const MyCommandCell = (cell) => (
        <MenuCommandCell
            {...cell}
            // onDelete={onCampaignDelete}
            onEdit={handleAdsetEdit}
            onPublish={onPublishOrUnpublish}
            onUnPublish={onPublishOrUnpublish}
            myMenuModel={smCampaignMenuModel}
        />
    )

    const getDynamicKeys = () => {
        const dynamicKeys = new Set();
        adsetData.forEach(adset => {
            if (dataItem.channel?.adType === ADS_TYPE.META) {
                if (adset.ad) {
                    Object.keys(adset.ad).forEach(key => {
                        if (!['_id', 'SID', 'addOn', 'addBy', 'modOn', 'modBy', 'product', 'brand', 'creatives'].includes(key)) {
                            dynamicKeys.add(`ad.${key}`);
                        }
                    });
                }
                if (adset.meta) {
                    Object.keys(adset.meta).forEach(key => dynamicKeys.add(`meta.${key}`));
                }
            }
            else if (dataItem.channel?.adType === ADS_TYPE.GOOGLE || dataItem.channel?.adType === ADS_TYPE.YOUTUBE) {
                if (adset.google) {
                    Object.keys(adset.google).forEach(key => dynamicKeys.add(`google.${key}`));
                }
            }
            else if (dataItem.channel?.adType === ADS_TYPE.LINKEDIN) {
                if (adset.linkedin) {
                    Object.keys(adset.linkedin).forEach(key => dynamicKeys.add(`linkedin.${key}`));
                }
            }
        });

        return dynamicKeys;
    }
    const dynamicKeys = getDynamicKeys();

    return (
        <BossDialog title={lang.campaign_dialog_header} onClose={onClose} width={"800px"}>
            <div className="d-flex justify-content-between align-items-center mb-3">
                <EditPageHeader showTitle={false} onSubmit={handleSubmit} onCancel={onClose} />
                <div className="d-flex align-items-center" style={{ width: "218px" }}>
                    <div className="mr-2">{budgetData?.currency?.description} </div>
                    <div className="bg-green-100 text-green-800">{`Available Budget: ${calculateRemainingSpendCap()}`} </div>
                </div>
            </div>
            <div className='row'>
                <div className="col-4">
                    <div className="flex justify-between items-center"> <label htmlFor="name">{lang.name_label} *</label> </div>
                    <input
                        type="text"
                        name="name"
                        placeholder="Enter Name"
                        value={dataItem.name}
                        onChange={onChange}
                        className="form-control form-control-sm"
                    />
                </div>
                <div className="col-4">
                    <label htmlFor="channel">{lang.channel_label} *</label>
                    <DropDownList
                        name="channel"
                        textField="adType"
                        dataItemKey="_id"
                        data={channels}
                        value={dataItem.channel}
                        onChange={onChange}
                        style={{ backgroundColor: 'white' }}
                    />
                </div>
                <div className="col-4">
                    <label htmlFor="budget">{lang.budget_label} *</label>
                    <DropDownList
                        name="budget"
                        textField="description"
                        dataItemKey="_id"
                        data={budgets}
                        value={dataItem.budget}
                        onChange={onChange}
                        disabled
                        style={{ backgroundColor: 'white' }}
                    />
                </div>
            </div>
            <div className='row mt-2'>
                <div className="col-4">
                    <div className="flex justify-between items-center"> <label htmlFor="start_time">{lang.start_time_label} *</label> </div>
                    <input
                        type="datetime-local"
                        id="start_time"
                        name="start_time"
                        value={dataItem.start_time}
                        onChange={onChange}
                        className="form-control form-control-sm"
                    />
                </div>
                <div className="col-4">
                    <div className="flex justify-between items-center"> <label htmlFor="end_time">{lang.end_time_label} *</label> </div>
                    <input
                        type="datetime-local"
                        id="end_time"
                        name="end_time"
                        value={dataItem.end_time}
                        onChange={onChange}
                        className="form-control form-control-sm"
                    />
                </div>
            </div>
            <div className='mt-2'>
                <div className="small text-secondary fw-bold"> {dataItem.channel?.adType ? utility.getKeyByValue(ADS_TYPE, dataItem.channel?.adType) : ""} </div>
                <div className="border border-secondary bg-white rounded shadow-sm p-2">
                    {dataItem.channel?.adType === ADS_TYPE.META &&
                        <MetaCampaignEditForm
                            dataItem={dataItem}
                            setDataItem={setDataItem}
                            minSpendCap={utility.convertCurrencyValue(budgetData.currency.description, 5000)}
                            budgetData={budgetData}
                        />
                    }
                    {(dataItem.channel?.adType === ADS_TYPE.GOOGLE || dataItem.channel?.adType === ADS_TYPE.YOUTUBE) &&
                        <GoogleCampaignForm
                            dataItem={dataItem}
                            setDataItem={setDataItem}
                            minSpendCap={utility.convertCurrencyValue(budgetData.currency.description, 5000)}
                            budgetData={budgetData}
                        />
                    }
                    {dataItem.channel?.adType === ADS_TYPE.LINKEDIN &&
                        <LinkedinCampaignForm
                            dataItem={dataItem}
                            budgetData={budgetData}
                            minSpendCap={utility.convertCurrencyValue(budgetData.currency.description, 5000)}
                            setDataItem={setDataItem}
                        />
                    }
                </div>
            </div>
            <div className='row mt-2'>
                <div className="col-12">
                    <div className='d-flex justify-content-between align-items-center'>
                        <AddRoundButton name="Create Adset" onClick={() => setShowAdsetPopup({ show: true, item: {} })} title={lang.create_adset_label} icon="plus" />
                        <div>{lang.adsets_label}({adsetData?.length ?? 0})</div>
                    </div>
                    <Grid resizable style={{ height: "27vh", marginTop: "5px" }} data={adsetData}>
                        <GridColumn cell={MyCommandCell} width={"50px"} />
                        <GridColumn field="ad_status" width="130px" title={lang.ad_status_column} cell={({ dataItem }) => <PublishOrUnPublishStatusCard dataItem={{ ...dataItem, ad_data: [dataItem] }} />} />
                        <GridColumn field='audience.name' title={lang.audience_column} width={"140px"} />
                        {[...dynamicKeys].map((key) => {
                            const title = key.split('.').slice(-1)[0].replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
                            return (<GridColumn key={key} field={key} title={title} width="150px" />);
                        })}
                        <GridColumn field='start_time' width="180px" title={lang.start_time_column} cell={DateTimeCell} />
                        <GridColumn field='end_time' width="180px" title={lang.end_time_column} cell={DateTimeCell} />
                    </Grid>
                </div>
            </div>
            {showAdsetPopup.show && (
                <BossDialog title={showAdsetPopup.item?._id ? lang.update_adset_label : lang.create_adset_label} width={"80%"} onClose={() => setShowAdsetPopup({ show: false, item: {} })} >
                    <SMAdsetForm campaign={dataItem} item={showAdsetPopup.item} onCancel={() => setShowAdsetPopup({ show: false, item: {} })} onSave={handleAdsetCreate} channel={dataItem?.channel} />
                </BossDialog>
            )
            }
        </BossDialog>
    )
}

export default SMCampaignEditForm;